export default "<td><span class=\"animated-bg\">&nbsp;</span></td>\n";